import React from "react";

import ToolLayout from "../ToolLayout";
import AccessibilityPlannerTool from "./AccessibilityPlannerTool";
import AccessibilityPlannerConfig from "./AccessibilityPlanner.config";

/**
 * AccessibilityPlannerPage
 *
 * Standalone, SEO-indexable page wrapper for the Accessibility Planner tool.
 */
const AccessibilityPlannerPage = () => {
  return (
    <ToolLayout
      title={AccessibilityPlannerConfig.title}
      description={AccessibilityPlannerConfig.description}
    >
      <AccessibilityPlannerTool />
    </ToolLayout>
  );
};

export default AccessibilityPlannerPage;
